import { StepType } from 'src/app/shared/shared.module';
import {
    getInputField, setAsRequired, setRegexValidation,
    getSelectField, getDateField,
    setYesNoValues, MinMaxAgeMustBe,setDisableWhen,setRequiredWhen
} from 'src/app/shared/form';
import { VisaType } from '../../visatypes';
import { isNullOrUndefined } from '../../../../../../app/core/utils';
import { FieldTooltip } from '../../field-tooltip.enum';
import { map } from 'rxjs/operators';


export class GOSIRemoval extends VisaType {
    GetRequesterSteps(operations?: () => string[]): StepType[] {

        return [
            {
                label: "Step 1",
                fields: [
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                          this.EmpProfileSearch(null, operations),
            
                        ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.gpn(),
                            this.gui(),
                           // this.gpnGuiSearchButton(operations)
                        ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.firstName(),
                            this.middleName(),
                            this.lastName()
                        ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.nationalityTypeWithSpecialExpact(),  
                            this.nationality(),
                            getSelectField(
                                "specialExpat",
                                "Special expat",
                                setYesNoValues(this.common.getSpecialExpactWrtNationalityType(setAsRequired(this.addFieldTooltipWithAdditionalConfig('special expat')))
                            )),
                        ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [

                            getSelectField(
                                "serviceLine.id",
                                "Service line",
                                this.common.getSelectFieldOptions(this.serviceLines$, '',
                                    setAsRequired())
                            ),
                            getSelectField(
                                "subServiceLine.id",
                                "Sub-service line",
                                this.common.getSelectFieldOptions(this.subServiceLines$, "serviceLine.id",
                                    setAsRequired())
                            ),
                            this.rank(),
                        ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.officeLocation(),
                            this.officeLE('EY legal entity'),
                            this.lastWorkingDay(),
                        //   this.grade(),
                        ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            getSelectField(
                                "cancellationReason.id",
                                "Reason for exit",
                                this.common.getSelectFieldOptions(this.cancellationReason$, '',
                                    setAsRequired())
                            ),
                            getInputField(
                                "otherReasonForCancellation",
                                "Other Reason for exit",
                                setDisableWhen((model) => !isNullOrUndefined(model.cancellationReason) && model.cancellationReason.id !== 12150,
                                setRequiredWhen((model) => !isNullOrUndefined(model.cancellationReason) && model.cancellationReason.id === 12150))
                            ),
                            getSelectField(
                                "terminationType.id", "Termination type",
                                this.common.getSelectFieldOptions(this.terminationtype$,'',
                                    setDisableWhen((model) =>
                                        !isNullOrUndefined(model.cancellationReason) && model.cancellationReason.id !== 5973,
                                        setRequiredWhen((model) =>
                                            !isNullOrUndefined(model.cancellationReason) && model.cancellationReason.id === 5973)
                                    ))
                            ),
                            this.RequestorName()
                        ]
                    },
                ]
            },
        ];

    }

    
  GetAccepterSteps(): StepType[] {
    return [
      {
        label: "Step 1",
        fields: [
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              this.visaProcessorByOfficeLE(setAsRequired()),
            //   this.Requestor()
            ]
          }
        ]
      }
    ];
  }



    GetApproverSteps(): StepType[] {

        return [
            {
                label: "Step 1",
                fields: [
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            // getInputField(
                            //     "nationalityIdNumber",
                            //     "National ID number",
                            //     setAsRequired()
                            // ),
                            // this.dateOfBirth(MinMaxAgeMustBe(10, 100, 'Date of birth cannot be in the past 10 years or in the future')),
                            // this.dateOfBirthOptional(MinMaxAgeMustBe(10, 100, 'Date of birth cannot be in the past 10 years or in the future')),
                            this.visaProcessorByOfficeLE(
                                setAsRequired()
                                ),
                          this.immigrationStatus(),
                        //   this.Requestor()
                        ]
                    }
                ]
            }
        ];
    }

}
